export default __webpack_public_path__ + "static/media/celuba-frente-2.30b413d8.jpg";